import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeftRight, Pause, Play } from "lucide-react";
import { usePlayer } from "../context/PlayerContext";
import { http } from "../lib/api";
import { Cover, EqBars } from "./Cover";

const MODE_LABEL = { cover: "Cover", extend: "Ilgesnė" };
const label = (v, i) => {
  if (v.mode === "source" || i === 0) return "Originalas";
  return MODE_LABEL[v.mode] || "Versija";
};

export const VersionCompare = ({ song }) => {
  const p = usePlayer();
  const [items, setItems] = useState([]);
  useEffect(() => { http.get(`/songs/${song.id}/versions`).then((r) => setItems(r.data)).catch(() => {}); }, [song.id]);
  if (items.length < 2) return null;

  const playingIdx = items.findIndex((v) => v.id === p.current?.id);
  const choose = (v) => {
    if (p.current?.id === v.id) return p.toggle();
    if (playingIdx >= 0) return p.switchTo(v, items);
    p.play(v, items);
  };
  const flip = () => choose(items[playingIdx >= 0 ? (playingIdx + 1) % items.length : 0]);

  return (
    <div data-testid="version-compare" className="mt-10">
      <div className="flex items-center justify-between mb-3">
        <p className="text-[11px] uppercase tracking-[0.14em] text-zinc-500 font-semibold">Versijų palyginimas</p>
        <button data-testid="version-ab-toggle" onClick={flip}
          className="flex items-center gap-2 px-4 py-2 rounded-full bg-[var(--c-violet)] text-white text-xs font-semibold hover:bg-[#b874f8] transition-colors">
          <ArrowLeftRight className="w-3.5 h-3.5" />A/B perjungti
        </button>
      </div>
      <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-3">
        {items.map((v, i) => {
          const on = p.current?.id === v.id;
          return (
            <div key={v.id} data-testid={`version-card-${v.id}`}
              className={`flex items-center gap-3 p-3 rounded-2xl border transition-colors ${on ? "border-[var(--c-orange)] bg-[var(--c-orange)]/10" : "border-[var(--c-line)] bg-[var(--c-surface)]"}`}>
              <button data-testid={`version-play-${v.id}`} onClick={() => choose(v)} className="relative w-14 h-14 rounded-xl overflow-hidden shrink-0 group">
                <Cover song={v} className="w-full h-full" />
                <span className="absolute inset-0 flex items-center justify-center bg-black/40">
                  {on && p.playing ? <Pause className="w-5 h-5" fill="currentColor" /> : <Play className="w-5 h-5" fill="currentColor" />}
                </span>
              </button>
              <div className="min-w-0">
                <p className="text-[10px] uppercase tracking-wider font-semibold text-[var(--c-orange)] flex items-center gap-1.5">
                  {String.fromCharCode(65 + i)} · {label(v, i)}{on && p.playing && <EqBars />}
                </p>
                {v.mode === "source" ? <p className="text-sm font-semibold truncate">{v.title}</p>
                  : <Link to={`/daina/${v.id}`} className="text-sm font-semibold truncate block hover:text-[var(--c-orange)]">{v.title}</Link>}
              </div>
            </div>
          );
        })}
      </div>
      <p className="text-xs text-zinc-500 mt-2">Perjungiant versijas grojimas tęsiamas nuo tos pačios vietos.</p>
    </div>
  );
};
